import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { fabric } from 'fabric';
import ObjectTool from './partials/ObjectTool';
import ToolBox from './partials/ToolBox';

import { scrollToElement } from '../../lib/userFunctions';
import { apiGetPictureTemp, apiStorePicture, apiStorePictureTemp } from './apiPicture';
import { toast } from "react-toastify";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createFetchErrorMessage } from 'utils/api/Api';
import { PhotoGuidePopup } from './partials/PhotoGuidePopup';

export const ReadingPictureForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { school, isbn } = useParams();
    const [isVisible, setIsVisible] = useState(true);
    const [guideVisible, setGuideVisible] = useState(true);
    const [help, setHelp] = useState(false);
    const [canvas, setCanvas] = useState(null);
    const queryClient = useQueryClient();
    
    useEffect(() => scrollToElement('lnb'), [dispatch, isbn]);

    useEffect(() => {
        const canvas = new fabric.Canvas('picture_canvas', {
            width: 805, height: 569,
            backgroundColor: "#fff",
            preserveObjectStacking: true,
        });
        // 오브젝트 삭제 기능 추가

        fabric.Object.prototype.controls.deleteControl = new fabric.Control({
            x: 0.5, y: -0.5,
            offsetY: 16,
            cursorStyle: 'pointer',
            mouseUpHandler: deleteObject,
            render: renderIcon,
            cornerSize: 25
        });
        setCanvas(canvas);
        function updateDimensions() {
            setIsVisible((window.innerWidth >= 768));
        }
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        document.addEventListener("keydown", onKeyDown);
        return () => {
            window.removeEventListener("resize", updateDimensions);
            document.removeEventListener("keydown", onKeyDown);
            //혹 시모르니까 여기서 이벤트 삭제
            document.removeEventListener("click", onClickDocument);
            setCanvas(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =================== 임시저장 관련 코드 시작 
    const getPictureTemp = useQuery({
        queryKey:['picture/temp', isbn], 
        queryFn:apiGetPictureTemp,
        refetchOnMount:'always'
    });

    const storePictureTempMutate = useMutation({
        mutationFn:apiStorePictureTemp,
        onSuccess:()=>{
            queryClient.invalidateQueries({queryKey:['picture/temp', isbn]});
            toast.success( "임시저장 작품은 30일 이후 자동삭제됩니다."  );
        },
        onError:(err)=>toast.error( createFetchErrorMessage(err, "임시저장 생성에 실패했습니다. 문제가 계속 되면 크롬 브라우저를 이용해주세요.").message )
    });


    const onSaveTemp = useCallback(()=>{
        if(storePictureTempMutate.isPending)return;
        if(!window.confirm("임시저장을 하겠습니까?"))return;
        const canvasData = JSON.stringify(canvas);
        storePictureTempMutate.mutate({ isbn, content:canvasData});
    }, [canvas, isbn, storePictureTempMutate]);

    const onLoadTemp = useCallback(()=>{
        if(!getPictureTemp.isSuccess) return;
        if(!window.confirm("임시저장을 불러 오겠습니까?"))return;
        canvas.loadFromJSON(getPictureTemp.data.data?.content, () => canvas.renderAll());
    }, [canvas, getPictureTemp]);
    



    // =================== 저장 관련 코드

    const storePictureMutate = useMutation({
        mutationFn:apiStorePicture,
        onSuccess:(res)=>{
            queryClient.invalidateQueries({queryKey:['picture/list', { id:null, isbn:null, best:"N", keyword:"", page:0, school:"", type:'picture', user:null }]});
            navigate(`/${school}/picture`)
        },
        onError:(err)=>toast.error( createFetchErrorMessage(err).message ),
    })

    const onSave = (event)=>{
        if(storePictureMutate.isPending)return toast.warning('저장중입니다.');
        if (canvas._objects != null) {
            if (canvas._objects.length === 0) {
                toast.error("공백 독서화는 저장 할 수 없습니다.");
                return false;
            }
            if (canvas._objects.length < 5) {
                toast.error("그림또는 글자를 5개 이상 입력해야합니다.");
                return false;
            }
        }
        
        try {
            // const imageData = canvas.toDatalessJSON({ format: 'jpeg' });
            const imageData = canvas.toDataURL('jpg', 0.75);
            // const imageData = canvas.toDataURL("image/png");
            storePictureMutate.mutate({isbn, imageData});
        } catch (ex) {
            onSaveTemp();
            toast.error('이미지 생성에 실패했습니다. 임시저장 되었습니다. 도서명을 포함해서 관리자에게 문의하세요');
        }
        
    };




    const onClickDocument = () => {
        document.removeEventListener("click", onClickDocument);
        setHelp(false);
    }

    const onTogglePictureHelp = () => {
        if (help) document.addEventListener('click', onClickDocument);
        setHelp(!help);
    }

    // 캔버스에서 오브젝트 삭제 
    const deleteObject = (eventData, transform)=>{
        var target = transform.target;
        var canvas = target.canvas;
        if (canvas === undefined) return;
        canvas.remove(target);
        canvas.requestRenderAll();
    }

    // 삭제 아이콘 추가
    const renderIcon = (ctx, left, top, styleOverride, fabricObject)=>{
        try {
            // if (!getVisibility(fabricObject))return;
            var img = document.createElement('img');
            img.src = `/static/images/picture/btn_delete.png`;
            var size = this.cornerSize;
            ctx.save();
            ctx.translate(left, top);
            // ctx.translate(fabricObject.left+fabricObject.width+size*0.5, fabricObject.top+size*0.5);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(img, -size / 2, -size / 2, size, size);
            ctx.restore();
        } catch (ex) {
            console.log(ex);
        }
    }



    const onKeyDown = (event)=>{
        switch (event.keyCode) {
            case 8: // eacape key 이건 글상자에서 삭제시 .. 동작을;; 
            case 46: //delete
                let object = canvas.getActiveObject();

                if (null !== object && undefined !== object && !object.isType('textbox')) {
                    if (object._objects === undefined) {
                        canvas.remove(object);
                    } else {
                        object._objects.forEach(element => {
                            canvas.setActiveObject(element);
                            canvas.remove(element);
                        });
                    }

                }
                break;
            default:
        }
    }



    return (
        <div className="section book_picture create create_picture">
            <div className="guide_box">
                <div className="inner">
                    <div>
                        <ul className="bullet_list">
                            <li>배경, 그림 이미지, 글자를 이용해, 책에 대한 나의 생각을 표현해보아요.</li>
                            <li className="warning"><i className="icon fas fa-exclamation-circle"></i> 낙서화 또는 그림 이미지 5개 이하로 넣은 경우, 독서사과 회수하고 비공개합니다.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="inner">

                {isVisible &&
                    <div className="create_form">
                        <div className="create_picture_area">
                            <div className="create_inner">
                                <ToolBox canvas={canvas} refs="sideMenu" ></ToolBox>

                                <div className="canvas_area">
                                    <ObjectTool canvas={canvas} refs="objectTool" onToggleHelp={onTogglePictureHelp} />
                                    {help &&
                                        <div className="guide_tooltip show">
                                            <p className="title">독서화 이용방법</p>
                                            <ul>
                                                <li>첫째(배경) : 표현하려고 하는 것이 어울릴 만한 배경을 찾아 선택해 주세요.</li>
                                                <li>둘째(그림) : 표현하려는 그림을 찾거나 검색해서 선택해 주세요.</li>
                                                <li>셋째(글자) : 글자를 추가하여 조금 더 재미있고 자세하게 만들어 완성해 보세요.</li>
                                            </ul>
                                        </div>
                                    }
                                    <div className="canvas_wrap" >
                                        <canvas id="picture_canvas"></canvas>
                                    </div>
                                </div>
                                <PhotoGuidePopup isVisible={guideVisible} onClose={()=>setGuideVisible(false)} />
                            </div>
                        </div>



                        <div className="cont_row">
                            <div className="create_btn">
                                <div className="bbs_btn alignR">
                                    <button type="button" className="btn _gray floatL" onClick={onSaveTemp}>{storePictureTempMutate.isPending?'임시저장중...':'임시저장'}</button>
                                    { getPictureTemp.isSuccess && getPictureTemp.data.data?.content && <button className="btn _gray floatL" onClick={onLoadTemp} >불러오기</button> }
                                    
                                    <button type="button" className="btn _turq" onClick={onSave}>{storePictureMutate.isPending?'저장중...':'저장'}</button>
                                    
                                    <Link className="btn _red" to={`/${school}/book/${isbn}/picture`}>닫기</Link>
                                </div>
                            </div>
                        </div>

                    </div>
                }

                {!isVisible &&
                    <div className="warning_message">
                        <p>독서화는 PC(가로가 큰 화면)로 이용해주세요.</p>
                    </div>
                }
            </div>

        </div>
    );
};